/** HUB-B.3 — Barre actions ventes (retrait + rapport) partagée. */
import React from 'react';

export default function HistoriqueVentesActionsBar({
  onRetrait,
  onRapportVendeur,
  testIdPrefix = 'historique',
}) {
  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid={`${testIdPrefix}-ventes-actions-bar`}>
      <button
        type="button"
        onClick={onRetrait}
        className="px-4 py-3 min-h-[44px] rounded-xl text-sm font-semibold border"
        style={{ borderColor: 'var(--rm-border-strong)', background: 'var(--rm-red-muted)', color: 'var(--rm-red-light)' }}
        data-testid={`${testIdPrefix}-retrait-button`}
      >
        Retrait caisse
      </button>
      <button
        type="button"
        onClick={onRapportVendeur}
        className="px-4 py-3 min-h-[44px] rounded-xl text-sm font-semibold border hover:bg-white/5"
        style={{ borderColor: 'var(--rm-border-subtle)', color: 'var(--rm-gray-200)' }}
        data-testid={`${testIdPrefix}-rapport-vendeur`}
      >
        Rapport vendeur (80mm)
      </button>
    </div>
  );
}
